module.exports = __webpack_public_path__ + "static/nae-6tukui-a8ccddf8c8bc3064077deab3900e4c3f.jpg";